export * from "./expandRangeAroundNode";
export * from "./extractFirstWordInRange";
export * from "./getActiveWordIndex";
export * from "./getNewWordNode";
export * from "./getNextRangeBoundary";
export * from "./getTextFromRange";
export * from "./isIrrelevantNode";
export * from "./isNode";
export * from "./isValidWord";
export * from "./removeHighlightNode";
export * from "./stopAllAudioPlayers";
